import { 
  PDFDocument, rgb, StandardFonts
} from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";

export const signOnDocuments = async (fileName, signatureName) => {
  // Load PDF
  const kuwaitKYC = await fetch(`/files/${fileName}.pdf`).then(res =>
    res.arrayBuffer()
  );

  const hasArabicCharacters = text => {
    if (!text) return false;
    const arabicRegex = /[\u0600-\u06FF]/;
    return arabicRegex.test(text);
  };

  const pdfDoc = await PDFDocument.load(kuwaitKYC);

  // Register fontkit so custom TTF can be embedded
  pdfDoc.registerFontkit(fontkit);

  // Load Cairo font from public folder
  const cairoFontBytes = await fetch("/fonts/Cairo-Regular.ttf").then(res =>
    res.arrayBuffer()
  );

  // Embed fonts
  const englishFont = await pdfDoc.embedFont(StandardFonts.HelveticaOblique);
  const arabicFont = await pdfDoc.embedFont(cairoFontBytes, { subset: true });

  const getFont = text => (hasArabicCharacters(text) ? arabicFont : englishFont);

  const pages = pdfDoc.getPages();
  const currentDate = new Date().toLocaleDateString();

  // SIGN POSITIONS
  if (fileName === "Kuwait_KYC_1") {
    const page = pages[1];
    if (page) {
      page.drawText(signatureName, {
        x: 510,
        y: 115,
        size: 20,
        font: getFont(signatureName),
        color: rgb(0, 0, 0),
      });

      page.drawText(currentDate, {
        x: 500,
        y: 85,
        size: 16,
        font: getFont(signatureName),
        color: rgb(0, 0, 0),
      });
    }
  } else {
    const page = pages[2];
    if (page) {
      page.drawText(signatureName, {
        x: 510,
        y: 245,
        size: 20,
        font: getFont(signatureName),
        color: rgb(0, 0, 0),
      });

      page.drawText(currentDate, {
        x: 500,
        y: 220,
        size: 15,
        font: getFont(signatureName),
        color: rgb(0, 0, 0),
      });
    }
  }

  const signedPdf = await pdfDoc.save();

  return new File([signedPdf], `${fileName}_Signed.pdf`, {
    type: "application/pdf",
  });
};
